import React from "react"
import { toggleColumnFilter } from "../models/FilterState"

interface ColumnFilterProps {
  filters
  setFilters
  field
  label
}

const ColumnFilter = (props: ColumnFilterProps) => {
  let { filters, setFilters, field, label } = props
  return (
    <label className="filter-subheader-label mt-1" htmlFor={field}>
      <input
        id={field}
        type="checkbox"
        checked={filters[field] === true}
        onChange={() => setFilters(toggleColumnFilter(filters, field))}
      />
      {label}
    </label>
  )
}

export default ColumnFilter
